import { useNormalizedReport } from './useNormalizedReport';
import { useMigratedReport } from './useMigrateReport';
import { useFilterUnifiedAnalyticsMetadataMetricsFromNonTableReports } from './useFilterIncompatibleUAMetrics';
export const useStandardizedReport = ({
  report,
  applyMigrateReport,
  runtimeOptions
}) => {
  const maybeFixedReport = useFilterUnifiedAnalyticsMetadataMetricsFromNonTableReports(report);
  const asyncNormalizedReport = useNormalizedReport({
    report: maybeFixedReport
  });
  const asyncMigratedReport = useMigratedReport({
    asyncReport: asyncNormalizedReport,
    deferred: !applyMigrateReport,
    useLocalReportMigrationApi: runtimeOptions && runtimeOptions.useLocalReportMigrationApi
  });
  return asyncMigratedReport;
};